<template>
  <generic-modal
    size="large"
    :title="$t('student module configuration')"
    icon="settings"
    image="/images/icons/student.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
  >
    <div class="description">
      <div class="ui blue segment">
        <div class="ui three item top attached tabular menu">
          <a class="active item" data-tab="branches">
            <i class="code branch icon"></i>
            {{ $t("branches") }}
          </a>
          <a class="item" data-tab="users">
            <i class="users icon"></i>
            {{ $t("users") }}
          </a>
          <a class="item" data-tab="student">
            <i class="user icon"></i>
            {{ $t("student") }}
          </a>
        </div>
        <div class="ui bottom attached active tab segment" data-tab="branches">
          <branches :setup="setup" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="users">
          <!-- <users :setup="setup" /> -->
          <users ref="users" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="student">
          <student :setup="setup" />
        </div>
      </div>
      <div class="ui orange segment">
        <div class="ui five item top attached tabular menu">
          <a class="active item" data-tab="careers">
            <i class="graduation cap icon"></i>
            {{ $t("careers") }}
          </a>
          <a class="item" data-tab="courses">
            <i class="chalkboard icon"></i>
            {{ $t("courses") }}
          </a>
          <a class="item" data-tab="periods">
            <i class="calendar alternate icon"></i>
            {{ $t("periods") }}
          </a>
          <a class="item" data-tab="studying_cycle">
            <i class="recycle icon"></i>
            {{ $t("studying cycle") }}
          </a>
          <a class="item" data-tab="studying_time">
            <i class="time icon"></i>
            {{ $t("studying time") }}
          </a>
        </div>
        <div class="ui bottom attached tab active segment" data-tab="careers">
          <careers :setup="setup" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="courses">
          <courses :setup="setup" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="periods">
          <periods :setup="setup" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="studying_cycle">
          <studying-cycle :setup="setup" />
        </div>
        <div class="ui bottom attached tab segment" data-tab="studying_time">
          <studying-time :setup="setup" />
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Branches from "./Branches.vue";
import Careers from "./Careers.vue";
import Courses from "./Courses.vue";
import Periods from "./Periods.vue";
import Users from "./Users.vue";
import StudyingCycle from "./StudyingCycle.vue";
import StudyingTime from "./StudyingTime.vue";
import Student from "./Student.vue";
// import DocumentTypes from "./DocumentTypes.vue";

export default {
  components: {
    "generic-modal": GenericModal,
    Branches,
    Careers,
    Courses,
    Periods,
    Users,
    Student,
    StudyingCycle,
    StudyingTime,
    // DocumentTypes
  },
  computed: {},
  data() {
    return {
      setup: {},
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_configuration/do-get-configuration")
      .then((conf) => {
        vm.setup = conf;
        vm.$refs.users.set_setup(vm.setup);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function () {
    let vm = this;
    this.$nextTick(function () {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        },
      });
    });
  },
};
</script>
